export default __webpack_public_path__ + "static/media/file-tender.46289a9f.svg";